import {
  generateClientRoutes,
  getClientName,
  getTenantFromToken
} from 'utils/routeUtils';

const getAppRoutes = () => {
  return new Promise((resolve, reject) => {
    function checkTokenAndGenerate() {
      const tenantId = getTenantFromToken();
      if (tenantId) {
        const clientName = getClientName();
        const routes = generateClientRoutes(clientName, tenantId);
        resolve(routes);
      } else {
        setTimeout(checkTokenAndGenerate, 1000);
      }
    }

    checkTokenAndGenerate();
  });
};

export const appRoutes = getAppRoutes();
export default appRoutes;
